module.exports = __webpack_public_path__ + "static/media/km.2c8e0e1d.webp";